import React from 'react';
import { useAccess } from '../../../../context/AccessContext';

export default function VidyutAi() {
    const email = localStorage.getItem("email");
    const { accessMap } = useAccess();
    
    let url = email
        ? `https://qa-gnai-agent.gna.energy/v2?user=${encodeURIComponent(email)}`
        : "https://qa-gnai-agent.gna.energy/v2";

    if (accessMap && (accessMap['jvvnl'] || accessMap['JVVNL'])) {
        url += email ? '&state=jvvnl' : '?state=jvvnl';
    }

    return (
        <div className="w-full h-[calc(100vh-85px)]">
            <iframe
                src={url}
                title="Vidyut AI Agent"
                className="w-full h-full border-none"
            />
        </div>
    );
}
